import { PlaybookLeverType, PlaybookRisk } from 'src/services';
import { TIER_A_METRICS } from '../GoalStep/constants';

export interface LeverOption {
  leverType: PlaybookLeverType;
  label: string;
  description: string;
}

export const LEVER_OPTIONS: LeverOption[] = [
  {
    leverType: 'ranking_strategy',
    label: 'Ranking strategy',
    description:
      'Change the weights that decide result order — similarity, bestsellers, trending, or any data field.',
  },
  {
    leverType: 'merchandising_rule',
    label: 'Merchandising rules',
    description:
      'Boost, bury, pin or filter items by brand, category, price, stock or a custom field.',
  },
  {
    leverType: 'view_config',
    label: 'View config',
    description: 'Front-end behavior: number of results, add-to-cart button, layout toggles.',
  },
];

export const RISK_RANK: Record<PlaybookRisk, number> = { low: 0, medium: 1, high: 2 };

export const RISK_LABEL: Record<PlaybookRisk, string> = {
  low: 'Low risk',
  medium: 'Medium risk',
  high: 'High risk',
};

export const getMetricLabel = (metric: string): string => {
  return TIER_A_METRICS.find(tierAMetric => tierAMetric.metric === metric)?.label || metric;
};

export const LEVER_LABEL: Record<PlaybookLeverType, string> = {
  ranking_strategy: 'Ranking strategy',
  merchandising_rule: 'Merchandising rule',
  view_config: 'View config',
  baseline: 'Baseline',
};

const COMPACT_METRIC_LABEL: Record<string, string> = {
  user_conversion: 'User CVR',
  average_order_value: 'AOV',
  average_revenue_per_user: 'ARPU',
};

export const getCompactMetricLabel = (metric: string): string => {
  return COMPACT_METRIC_LABEL[metric] || getMetricLabel(metric);
};

export const formatDataFieldsNote = (fields: string[]): string => {
  const label =
    fields.length === 1 ? `the ${fields[0]} data field` : `the ${fields.join(', ')} data fields`;
  return `Needs ${label}`;
};
